import CancelSubscriptionAccountStats from "~/records/record.cancelSubscriptionAccountStats.jsx";
import * as actionTypes from "~/store/action_types";

const cancelSubscriptionAccountStats = (state = new CancelSubscriptionAccountStats(), action) => {
  switch (action.type) {
    case actionTypes.GET_ACCOUNT_STATS_BEFORE_CANCELLATION_LOADING:
      return state;

    case actionTypes.GET_ACCOUNT_STATS_BEFORE_CANCELLATION_SUCCESS:
      return new CancelSubscriptionAccountStats({
        ...state.toObject(),
        ...action.response,
      });

    case actionTypes.GET_ACCOUNT_STATS_BEFORE_CANCELLATION_ERROR:
      return state;

    default:
      return state;
  }
};

export default cancelSubscriptionAccountStats;
